import { render, staticRenderFns } from "./cLandingLinksAlt.vue?vue&type=template&id=656ff008&scoped=true"
import script from "./cLandingLinksAlt.vue?vue&type=script&lang=js"
export * from "./cLandingLinksAlt.vue?vue&type=script&lang=js"
import style0 from "./cLandingLinksAlt.vue?vue&type=style&index=0&id=656ff008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ff008",
  null
  
)

export default component.exports